<template>
  <b-card class="create-clinic-form">
    <h5 class="mb-4">
      <i class="fas fa-hospital-alt mr-2 text-primary"></i>
      Create New Clinic
    </h5>
    <b-form @submit.prevent="handleSubmit">
      <ExcelFileUploader
        v-model="file"
        label="Upload Excel File *"
        :state="$v.file.$dirty ? !$v.file.$error : null"
        @input="$v.file.$touch()"
      />
      <b-form-invalid-feedback :state="!$v.file.$error">
        Excel file is required
      </b-form-invalid-feedback>
      <b-form-group class="mt-3">
        <b-form-checkbox v-model="nhsoEnabled">
          <i class="fas fa-shield-alt mr-1"></i>
          Enable NHSO Integration
        </b-form-checkbox>
      </b-form-group>
      <b-form-group class="mt-2">
        <b-form-checkbox v-model="isTantata">
          <i class="fas fa-clinic-medical mr-1"></i>
          Tantata Clinic (3-digit branch numbers)
        </b-form-checkbox>
      </b-form-group>
      <b-button type="submit" variant="success" :disabled="loading" block>
        <i class="fas mr-2" :class="loading ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>
        {{ loading ? 'Creating Clinic...' : 'Create Clinic' }}
      </b-button>
    </b-form>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
import ExcelFileUploader from './ExcelFileUploader.vue';

export default {
  name: 'CreateClinicForm',
  components: { ExcelFileUploader },
  data() {
    return {
      file: null,
      nhsoEnabled: false,
      isTantata: false
    };
  },
  validations: {
    file: { required }
  },
  computed: {
    ...mapGetters('moduleSuperadmin', ['isCreateClinicLoading']),
    loading() {
      return this.isCreateClinicLoading;
    }
  },
  methods: {
    ...mapActions('moduleSuperadmin', ['createClinic']),
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('nhso', this.nhsoEnabled ? 'true' : 'false');
      formData.append('isTantata', this.isTantata ? 'true' : 'false');
      try {
        const result = await this.createClinic(formData);
        this.$emit('success', result.data);
        this.resetForm();
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to create clinic';
        this.$bvToast.toast(message, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000
        });
      }
    },
    resetForm() {
      this.file = null;
      this.nhsoEnabled = false;
      this.isTantata = false;
      this.$v.$reset();
    }
  }
};
</script>
